export const menuItems = [
  {
    name: "products",
    label: "products",
    items: [
      { name: "pricing", label: "retainers" },
      { name: "staffing", label: "mentorship + staffing" },
      { name: "academy", label: "academy" },
    ],
  },
  {
    name: "tools",
    label: "platform",
    items: [
      { name: "labs", label: "labs" },
      { name: "patterns", label: "patterns" },
      { name: "slack", label: "slack" },
      { name: "career-path", label: "career path" },
      { name: "time-tracker", label: "time tracker" },
      { name: "staffing", label: "junior staffing" },
    ],
  },
  {
    name: "examples",
    label: "examples",
  },
  {
    name: "team",
    label: "team",
  },
  {
    name: "pricing",
    label: "pricing",
  },
];
